import React from 'react';

// eslint-disable-next-line import/prefer-default-export
const FullNameField = ({ record = {} }) => {
  if (!record) {
    return null;
  }
  const {
    email,
    firstName,
    middleName,
    lastName,
    role,
  } = record;
  const fullName = (`${firstName || ''} ${middleName || ''} ${lastName || ''}`.trim() || email);
  return (
    <span
      style={{
        fontSize: '0.875rem',
        fontWeight: 400,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: '1.46429em',
      }}
    >
      {fullName} {role && `(${role})`}
    </span>
  );
};

FullNameField.defaultProps = {
  label: 'Full Name',
  addLabel: true,
};

export default FullNameField;



// WEBPACK FOOTER //
// ./src/components/General/FullNameField.jsx